import { differenceInCalendarDays, isValid, parseISO, startOfDay } from 'date-fns';

export const getUpcomingStay = ({
	checkInTime,
	isAuthenticated,
	now = new Date(),
}: {
	checkInTime?: string;
	isAuthenticated: boolean;
	now?: Date;
}) => {
	if (!isAuthenticated) return 'na';
	if (!checkInTime) return 'no upcoming stay';

	const checkInDate = parseISO(checkInTime);
	if (!isValid(checkInDate)) return 'no upcoming stay';

	const daysUntilCheckIn = differenceInCalendarDays(checkInDate, startOfDay(now));

	if (daysUntilCheckIn > 0) return daysUntilCheckIn.toString();
	if (daysUntilCheckIn === 0) return 'in stay';

	return 'no upcoming stay';
};
